import SectionMessage from '@atlaskit/section-message';
import { BodySmall, checkIfEditionChargedSeparatelyInSandboxFromOfferingsByEdition, checkSandboxEligibilityFromOfferings, getParentEditionFromOfferings } from '@atlassian/mpac-primitives';
import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const AppEditionsSandboxSectionMessages = _ref => {
  let {
    eligibleOfferings,
    selectedEditionTypeValue
  } = _ref;
  const isEditionChargedSeparatelyInSandbox = checkIfEditionChargedSeparatelyInSandboxFromOfferingsByEdition(eligibleOfferings, selectedEditionTypeValue);
  const isAppEligibleForFreeOnSandboxAndStandardSelected = Boolean(eligibleOfferings && checkSandboxEligibilityFromOfferings(eligibleOfferings).isSandbox && getParentEditionFromOfferings(eligibleOfferings) === MarketplaceStoreEditionType.Advanced && selectedEditionTypeValue === MarketplaceStoreEditionType.Standard);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isEditionChargedSeparatelyInSandbox && /*#__PURE__*/_jsx(SectionMessage, {
      children: /*#__PURE__*/_jsx(BodySmall, {
        children: "You\u2019ll be charged for the Advanced edition in addition to your existing Standard edition."
      })
    }), isAppEligibleForFreeOnSandboxAndStandardSelected && /*#__PURE__*/_jsx(SectionMessage, {
      children: /*#__PURE__*/_jsx(BodySmall, {
        children: "As you\u2019ve already purchased the Advanced edition of this app, you can install the Standard edition for free."
      })
    })]
  });
};